module.exports = __webpack_public_path__ + "static/media/rsr.cc14fbf9.jpg";